export const stripPhone = (phone: string) => phone.replace(/[^+\d]+/g, '');
